import * as mutationTypes from 'store/mutationTypes'
import venueService from 'api/venue'

/**
 * @return {Promise}
 */
export const getVenue = function ({ commit }, venueId) {
  if (!venueId) return Promise.reject('venueId is required')

  return venueService.getById(venueId).then((result) => {
    this.loading = false

    return commit(mutationTypes.SET_CURRENT_VENUE, result.data)
  })
}

/**
 * @return {Promise}
 */
export const setCurrentVenue = function ({ commit }, venue) {
  if (!venue) return Promise.reject('venue is required')

  return commit(mutationTypes.SET_CURRENT_VENUE, venue)
}



// WEBPACK FOOTER //
// ./src/store/modules/venue/actions.js